export const SUPPORTED_LOCALES = [
    'en',
    'es'
];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_LABELS = {
    en: 'English',
    es: 'Español'
};
export const LOCALE_COOKIE_NAME = 'anchor_locale';
export const LOCALE_COOKIE_EXPIRY = new Date('2099-12-31');
export function isSupportedLocale(value) {
    return typeof value === 'string' && SUPPORTED_LOCALES.includes(value);
}
export function readLocaleCookie(cookieString) {
    var _match_split_;
    const match = cookieString.split(';').find((c)=>c.trim().startsWith("".concat(LOCALE_COOKIE_NAME, "=")));
    if (!match) {
        return DEFAULT_LOCALE;
    }
    const value = (_match_split_ = match.split('=')[1]) === null || _match_split_ === void 0 ? void 0 : _match_split_.trim();
    return isSupportedLocale(value) ? value : DEFAULT_LOCALE;
}
